import { Fancybox } from "@fancyapps/ui";
const urlParams = new URLSearchParams(window.location.search);

Fancybox.bind("[data-fancybox]", {

});

if (urlParams.has('redirect')) {
  new Fancybox(
    [
      {
        src: "#popup_redirect"
      },
    ]
  );
}
